<ng-container *ngrxLet="theme$ | async" />
